import type { FC } from 'react';
import { QEmptyState } from '../EmptyState/EmptyState';
import { DataProps } from '../../utils';
import { useLibraryTranslation } from '../../i18n';

export type QNotFoundProps = DataProps;

/**
  Not Found component serves as a fallback for cases where no routes in your application match the requested path
 */
export const QNotFound: FC<QNotFoundProps> = (props) => {
  const { t } = useLibraryTranslation();
  return (
    <QEmptyState
      title={t('notFound.title')}
      subtitle={t('notFound.subtitle')}
      {...props}
    />
  );
};
